<block-ui class="custom_loader">
  <div class="pages-body flex flex-column" style="height: auto !important">
    <div
      class="p-fluid grid card flex"
      style="padding-top: 25px; padding-right: 15px"
    >
      <div
        class="col-12 flex justify-content-between flex-row align-items-center"
      >
        <div class="align-self-center mt-auto mb-auto">
          <div class="pages-panel card flex flex-column">
            <div style="padding-top: 5px">&nbsp;</div>
            <h4>Access Denied</h4>
            <div class="topbar-left ml-5 flex flex-column" routerLink="/">
              <div class="logo">
                <img
                  src="../../../../assets/images/CareFinity.png"
                  alt=""
                  style="height: 50px; width: 200px"
                />
              </div>
            </div>

            <div
              class=""
              style="
                padding-top: 30px;
                padding-left: 15px;
                font-size: 20px;
                color: maroon;
              "
            >
              <b>You are not authorized to access this resource.</b>
              <hr style="border-top: 2px solid #e8e9e6 !important" />
            </div>
            <div style="padding-top: 2px">&nbsp;</div>

            <p-button
              label="Homepage"
              [routerLink]="['/']"
              icon="pi pi-check"
            ></p-button>

            <div style="color: maroon">
              <i>
                For technical assistance and/or questions regarding CareFinity,
                please contact eMedApps.&nbsp; www.emedapps.com
              </i>
            </div>
            <div>&nbsp;</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</block-ui>
